export default __webpack_public_path__ + "static/media/car.12ece22f.png";